import { ThemeProvider as ThemeProviderMui } from '@mui/material/styles';
import GlobalStyles from '@mui/material/GlobalStyles';
import React from 'react';
import PropTypes from 'prop-types';
import theme, { COLORS } from './index';

const defaultFont = "'Poppins'";

export const ThemeProvider = ({ children }) => {
  return (
    <ThemeProviderMui theme={theme}>
      <GlobalStyles
        styles={{
          body: {
            fontFamily: defaultFont,
            fontSize: '14px',
            color: COLORS.black,
            backgroundColor: COLORS.lightGray
          },
          button: { fontFamily: defaultFont }
        }}
      />
      {children}
    </ThemeProviderMui>
  );
};

ThemeProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default ThemeProvider;
